import { render, staticRenderFns } from "./ChannelThumbNail.html?vue&type=template&id=2bc1cb32&scoped=true&"
import script from "./ChannelThumbNail.js?vue&type=script&lang=js&"
export * from "./ChannelThumbNail.js?vue&type=script&lang=js&"
import style0 from "./ChannelThumbNail.scss?vue&type=style&index=0&id=2bc1cb32&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bc1cb32",
  null
  
)

export default component.exports